<template>
  <my-container>
    <main-title center wave>
      Благодарности
    </main-title>
    <main-text center class="mb-2" v-for="(item, k) in gratitudeData" :key="k">
      {{ item.name }}
    </main-text>
  </my-container>
</template>

<script>
import API from "@/common/api/api.functions";
import MyContainer from "@/components/MyContainer";
import MainTitle from "@/components/MainTitle";
import MainText from "@/components/MainText";

export default {
  name: "Gratitude",
  components: { MainText, MainTitle, MyContainer },
  data: () => ({
    gratitudeData: []
  }),
  methods: {
    async getGratitudeData() {
      this.gratitudeData = await API.getGratitude().then(
        response => response.data
      );
    }
  },
  mounted() {
    this.getGratitudeData();
  }
};
</script>
